import { Component, Input, OnInit } from '@angular/core';
import { VhAlgorithm, VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { ChooseIconComponent } from 'vhobjects-service';
import { FunctionService } from 'vhobjects-service/src/services';
// import { ChooseIconComponent } from '../../../icon/choose-icon/choose-icon.component';

@Component({
  selector: 'app-config-breadcrumb',
  templateUrl: './config-breadcrumb.component.html',
  styleUrls: ['./config-breadcrumb.component.scss']
})
export class AtwBreadcrumbConfig implements OnInit {
  // @Input() data_tool: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config : string; // xác định trang đang ở page hay preview
  // @Input() id_subproject : any;
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;
  @Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() blocks_of_page: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    },
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 2,
    }
  ];

  effect_hover = [];
  effect_hover_data: any = {};

  id_subproject: any = "";

  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'mac_dinh',
      img: 'src/assets/root/icon/user/gdDefault.png',
      deg: '180deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'tu_trai_sang_phai',
      img: 'src/assets/root/icon/user/gdToRight.png',
      deg: '90deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'tu_phai_sang_trai',
      img: 'src/assets/root/icon/user/gdToLeft.png',
      deg: '270deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];

  /** Chứa các trang mà trang hiện tại có thể link đến */
  arr_link_page: any = [];
  /** Loại liên kết để chọn */
  type_page = ['blank', 'detail_category']
  type_link: any = [
    {value: 'none', label: 'khong'},
    {value: 'page_link', label: 'den_trang'},
  ];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb, 
    private http: HttpClient,
    private route: ActivatedRoute,
    private vhEventMediator: VhEventMediator,
    private dialog: MatDialog,
    private vhAlgorithm: VhAlgorithm,
    public functionService: FunctionService
  ) {
    this.route.params.subscribe((routeParam) => {
      this.id_subproject = routeParam.id_project
    })
  }


  ngOnInit(): void {     
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/breadcrumb.json'), 
    ]) .subscribe(([effects]:any)=>{
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    });

    this.getLinkAllPages();
  }


  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }  
  }

  
  /**
   * Xử lý lấy link các page về.
   */
  getLinkAllPages() {
    this.vhQueryAutoWeb.getPages_byFields({ type: { $in: this.type_page } }).then((pages:any) => {
      // Dùng cho trường hợp trang không có name_vn (Hoặc functionService.selectedLanguageCode)
      const pagesNew = pages.map((page) => {
        // if (!page.name) console.warn('Không có name', page)
        if (!page['name_' + this.functionService.selectedLanguageCode] && page.name) {
          return {
            ...page,
            ['name_' + this.functionService.selectedLanguageCode]: page.name
          };
        } else return page;
      });
      this.arr_link_page = this.vhAlgorithm.sortVietnamesebyASC(pagesNew, 'name_' + this.functionService.selectedLanguageCode);
    });
  }


  customize = [];
  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[1])
  }


  /* ------------------------------ PHẦN XỬ LÝ GRADIENT ----------------------------- */
  
  /**
   * Cập nhật Gradient
   */
  handleSetGradientTextBacklink() {
    if (this.config['background-image-backlink'].gradient_check) {
      this.class['breadcrumb__wrapper--backlink']['background-image'] = `linear-gradient(${this.config['background-image-backlink']['gradient_direction']} ${this.config['background-image-backlink']['gradient_arr_gradient']})`;
      this.class['breadcrumb__wrapper--backlink']['-webkit-text-fill-color'] = 'transparent';
      this.class['breadcrumb__wrapper--backlink']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['breadcrumb__wrapper--backlink']['background-image'] = 'none';
      this.class['breadcrumb__wrapper--backlink']['-webkit-text-fill-color'] = 'unset';
      this.class['breadcrumb__wrapper--backlink']['-webkit-background-clip'] = 'unset';
    }
    this.updateObject();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOptionBacklink(direction, event) {
    this.config['background-image-backlink']['gradient_direction'] = direction.direction;
    this.handleSetGradientTextBacklink();
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradientBacklink(e) {
    this.config['background-image-backlink']['gradient_opacity'] = e.target.value;
    const newArr = this.config['background-image-backlink']['gradient_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image-backlink']['gradient_opacity'] / 100})`
    })
    this.config['background-image-backlink']['gradient_arr_gradient'] = newArr;
    
    this.handleSetGradientTextBacklink();
  }

  openbgGradientBacklink() {
    document.getElementById('input-gradient-backlink').click();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradientBacklink() {
    this.config['background-image-backlink']['gradient_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image-backlink']['gradient_background_color'])}, ${this.config['background-image-backlink']['gradient_opacity'] / 100})`
    );
    this.handleSetGradientTextBacklink();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradientBacklink(index) {
    this.config['background-image-backlink']['gradient_arr_gradient'].splice(index, 1);
    this.handleSetGradientTextBacklink();
  }

  /**
   * Cập nhật Gradient
   */
  handleSetGradientTextCurrent() {
    if (this.config['background-image-current'].gradient_check) {
      this.class['breadcrumb__wrapper--current']['background-image'] = `linear-gradient(${this.config['background-image-current']['gradient_direction']} ${this.config['background-image-current']['gradient_arr_gradient']})`;
      this.class['breadcrumb__wrapper--current']['-webkit-text-fill-color'] = 'transparent';
      this.class['breadcrumb__wrapper--current']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['breadcrumb__wrapper--current']['background-image'] = 'none';
      this.class['breadcrumb__wrapper--current']['-webkit-text-fill-color'] = 'unset';
      this.class['breadcrumb__wrapper--current']['-webkit-background-clip'] = 'unset';
    }
    this.updateObject();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOptionCurrent(direction, event) {
    this.config['background-image-current']['gradient_direction'] = direction.direction;
    this.handleSetGradientTextCurrent();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradientCurrent(e) {
    this.config['background-image-current']['gradient_opacity'] = e.target.value;
    const newArr = this.config['background-image-current']['gradient_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image-current']['gradient_opacity'] / 100})`
    })
    this.config['background-image-current']['gradient_arr_gradient'] = newArr;
    
    this.handleSetGradientTextCurrent();
  }
  openbgGradientCurrent() {
    document.getElementById('input-gradient-current').click();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradientCurrent() {
    this.config['background-image-current']['gradient_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image-current']['gradient_background_color'])}, ${this.config['background-image-current']['gradient_opacity'] / 100})`
    );
    this.handleSetGradientTextCurrent();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradientCurrent(index) {
    this.config['background-image-current']['gradient_arr_gradient'].splice(index, 1);
    this.handleSetGradientTextCurrent();
  }


  /* ----------------------------- CÁC HÀM UPDATE ----------------------------- */

  // /**
  //  * Hàm update object vào database.
  //  */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }

  // /**
  //  * Hàm update class
  //  */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  // /**
  //  * Hàm update config`
  //  */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }


  // /**
  //  * Hàm update staticdata
  //  */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }

  get selectedLink(): any {
    if (!this.arr_link_page?.length) return null; // Tránh lỗi khi mảng rỗng hoặc undefined
  
    return this.arr_link_page.find(page => 
      (page.type === 'detail_category' && page.link === this.staticdata.link_category) ||
      (page.type !== 'detail_category' && page.link === this.staticdata.link)
    ) || null; // Trả về null nếu không tìm thấy
  }
  
  set selectedLink(page: any) {
    if (!page) {
      this.staticdata.link = null;
      this.staticdata.link_category = null;
      return;
    }
  
    if (page.type === 'detail_category') {
      this.staticdata.link_category = page.link;
      this.staticdata.link = null; // Xóa giá trị không dùng
    } else {
      this.staticdata.link = page.link;
      this.staticdata.link_category = null; // Xóa giá trị không dùng
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event){
    if(event.width) this.class['breadcrumb-object']['width'] = event.width + 'px';
    if(event.height) this.class['breadcrumb-object']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }


  /* ----------------------- PHẦN XỬ LÝ CHO MENU CONFIG ----------------------- */

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };

  /**
   * Hàm mở ra hộp thoại chọn icon
   */
  openDialogChooseIcon() {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.staticdata.icon = result.icon;
        this.updateStaticData();
      }
    });
  }
}
